
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PermissionItemProps } from ".";
import { loading, create } from "store/permission";

interface ApiPermissionCreateInputProps extends Omit<PermissionItemProps, "id"> {
}

type ApiPermissionCreateOutputProps = OutputBaseProps<{ item: PermissionItemProps; }, ApiPermissionCreateInputProps>

export const apiPermissionCreate = async (data: ApiPermissionCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiPermissionCreateOutputProps>("/api/permission/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};